'use client'

import { cva } from 'class-variance-authority'

import { cn } from '@/utils'

import BaseSwitch, { toggleGroupCls, toggleGroupItemCls } from './BaseSwitch'

const clone1toggleGroupCls: typeof toggleGroupCls = cva('px-[0.1875rem]', {
	variants: {
		visual: { primary: 'gap-2 border-none', secondary: '' },
	},
})

const clone1ToggleGroupItemCls: typeof toggleGroupItemCls = cva('', {
	variants: {
		visual: {
			primary:
				'h-10 border data-[state=off]:border-border-grey data-[state=on]:border-transparent data-[state=off]:text-dark-grey',
			secondary: '',
		},
	},
})

const Clone1Switch: typeof BaseSwitch = ({ className, ...props }) => {
	return (
		<BaseSwitch
			{...props}
			className={cn(clone1toggleGroupCls({ visual: props.visual }), className)}
			toggleItemCls={clone1ToggleGroupItemCls({ visual: props.visual })}
		/>
	)
}

export default Clone1Switch
